import { track } from "@amplitude/analytics-browser";

interface ExploreFilterChipsProps {
  selectedFilter: "all" | "nearby";
  onFilterChange: (filter: "all" | "nearby") => void;
  initLoading: boolean;
}

export function ExploreFilterChips({
  selectedFilter,
  onFilterChange,
  initLoading,
}: ExploreFilterChipsProps) {
  return (
    <div
      className={`${
        initLoading ? "skeleton-wave-item" : ""
      } flex justify-center mt-4 gap-2 px-4`}
      style={initLoading ? { animationDelay: "0s" } : {}}
    >
      <div
        className={`px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-all duration-300 ease-in-out ${
          selectedFilter === "nearby"
            ? "bg-[#1562fc] text-white shadow-md"
            : "bg-gray-100 text-gray-600 hover:bg-gray-200"
        }`}
        onClick={() => {
          track("찐후기 내 근처 매장만 보기 필터 클릭");
          onFilterChange("nearby");
        }}
      >
        내 근처
      </div>
      <div
        className={`px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-all duration-300 ease-in-out ${
          selectedFilter === "all"
            ? "bg-[#1562fc] text-white shadow-md"
            : "bg-gray-100 text-gray-600 hover:bg-gray-200"
        }`}
        onClick={() => {
          track("찐후기 모두보기 필터 클릭");
          onFilterChange("all");
        }}
      >
        다른지역 구경하기
      </div>
    </div>
  );
}
